import { IStore } from 'store/configureStore';

export const selectReportsState = (state: IStore) => {
    return state.modules.settings.clientsSettings.clients.reports;
};

export const selectIsLoadingLatestPayRatesReport = (state: IStore) =>
    selectReportsState(state).latestSubassignmentsPayRatesReportIsLoading;
